import React from 'react';
import ReactDOM from 'react-dom';
import { Route, BrowserRouter as Router, Routes, Navigate } from 'react-router-dom'
import './index.scss';
import Notfound from './templates/Notfound';
import TplIndex from './templates/TplIndex';

const routes = (   
	<Router>
	
        <Routes>               
            <Route path="/" element={<TplIndex />} />
            <Route path="/project/:slug" element={<TplIndex />} />
            <Route path="/article/:slug" element={<TplIndex />} /> 
			<Route path="/:slug" element={<TplIndex />} />           
			<Route path="*" element={<Notfound />} />
        </Routes>
      </Router> 
)

ReactDOM.render(routes, document.getElementById('root'));